<template>
  <div class="asc-details-item--container">
    <div>
      <asc-label :value="title" input-label></asc-label>
    </div>
    <template v-if="isValueString">
      <div>
        <asc-label :value="value"></asc-label>
      </div>
    </template>
    <template v-if="isValueArray">
      <div v-for="(item, index) in value" :key="index">
        <asc-label :value="item"></asc-label>
      </div>
    </template>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscDetailsItem',

  components: {
    AscLabel,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Array],
      required: true,
    },
  },

  computed: {
    isValueString() {
      return typeof this.value === 'string'
    },
    isValueArray() {
      return typeof this.value === 'object'
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-details-item--container {
  margin-top: $size-medium;
}
</style>
